module.exports = __webpack_public_path__ + "img/notifications.5eb55580.svg";